var React = require('react');

function IconQuotes (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .fac384c8-d16e-4a6e-9525-1930e1a54a7f {\n        fill: #ffb500;\n      }\n    ")),React.createElement("g",{"id":"b082e864-4997-426f-9f18-0b1e62091f6f","data-name":"Group 361","key":1},React.createElement("path",{"id":"a04bb17b-3851-44c3-a03a-734a973872ed","data-name":"Path 361","className":"fac384c8-d16e-4a6e-9525-1930e1a54a7f","d":"M.23736,48.933,5.95036,0h22.355V30.553c13.91.746,22.355,6.21,22.355,20.368,0,16.394-10.681,20.368-25.584,20.368C8.93036,71.288-1.74964,65.326.23736,48.933Zm61.849,0L67.79935,0h22.355V30.553c13.91.746,22.355,6.21,22.355,20.368,0,16.394-10.681,20.368-25.584,20.368C70.78035,71.288,60.09935,65.326,62.08635,48.933Z"}))]);
}

IconQuotes.defaultProps = {"id":"a53063ed-92c0-406c-8028-986f8db51c28","data-name":"Layer 1","viewBox":"0 0 112.50934 71.289"};

module.exports = IconQuotes;

IconQuotes.default = IconQuotes;
